import { createContext } from "react";
import { createIframeTheme } from "./Utilities";

const ThemeContext = createContext(createIframeTheme("blue"));
export default ThemeContext;
